import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';
import type { ResolvedSearchProfile } from 'app/domain';

class SearchProfileService {
  readonly #httpClient: Axios;
  readonly baseUrl: string;

  constructor(httpClient: Axios) {
    this.#httpClient = httpClient;
    this.baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.searchProfile}`;
  }

  // No parameters: the visitor is resolved server-side, not described here.
  get = async (): Promise<ResolvedSearchProfile> => {
    const response = await this.#httpClient.get<ResolvedSearchProfile>(
      this.baseUrl
    );

    return response.data;
  };
}

export default SearchProfileService;
